var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnbIco3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 54",
    style: {
      enableBackground: "new 0 0 56 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.46,2.4H7.54c-2.35,0-4.25,1.9-4.25,4.25v40.7c0,2.35,1.9,4.25,4.25,4.25h40.92c2.35,0,4.25-1.9,4.25-4.25 V6.65C52.71,4.3,50.81,2.4,48.46,2.4z M48,45.73c0,0.78-0.63,1.42-1.42,1.42H9.42C8.64,47.15,8,46.51,8,45.73V8.27 c0-0.78,0.63-1.42,1.42-1.42h37.16c0.78,0,1.42,0.63,1.42,1.42V45.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.55,24.17h17.35c1.18,0,2.14-0.96,2.14-2.14c0-1.18-0.96-2.14-2.14-2.14H16.55c-1.18,0-2.14,0.96-2.14,2.14 C14.41,23.21,15.37,24.17,16.55,24.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.99,11.96H16.55c-1.18,0-2.14,0.96-2.14,2.14c0,1.18,0.96,2.14,2.14,2.14h23.45c1.18,0,2.14-0.96,2.14-2.14 C42.13,12.91,41.17,11.96,39.99,11.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.99,28.44H16.55c-1.18,0-2.14,0.96-2.14,2.14v0v4.28v2.69v4.28c0,1.18,0.96,2.14,2.14,2.14h23.45 c1.18,0,2.14-0.96,2.14-2.14v-4.28v-2.69v-4.28v0C42.13,29.4,41.17,28.44,39.99,28.44z M37.85,34.86v2.69v2.14H18.69v-2.14v-2.69 v-2.14h19.17V34.86z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco3);
export default __webpack_public_path__ + "static/media/gnb_ico3.59dbcf3116971c850b4cf3e3babb6718.svg";
export { ForwardRef as ReactComponent };